export const kylendarPurchaseUrls = {
  mini: {
    us: "https://www.amazon.com/dp/B0H35L3C5Y?th=1",
    jp: "https://www.amazon.co.jp/gp/product/B0H35NZ6GX?th=1",
    uk: "https://www.amazon.co.uk/dp/B0H35L3C5Y?th=1",
  },
  standardV1: {
    us: "https://www.amazon.com/dp/B0G1XRX2Y3",
    uk: "https://www.amazon.co.uk/dp/B0H1C3QB5V",
  },
  standardV2: {
    us: "https://www.amazon.com/dp/B0GQYMCMKX?th=1",
    jp: "https://www.amazon.co.jp/gp/product/B0H13WHCJW?th=1",
    uk: "https://www.amazon.co.uk/dp/B0H114L5X5",
  },
};
